/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getTextContrast } from "../../../../../utils";
import get from "lodash/get";
import "./button.module.css";

export const Button = ({
  text,
  clickHandler,
  disable,
  enableEnterClick = false,
  enableLoader = false,
}) => {
  const [loading, setLoading] = useState(false);

  const enableDarkMode = useSelector((state) =>
    get(state, ["header", "isDarkModeEnabled"], false)
  );
  const { login = {}, general = {} } = useSelector((state) =>
    get(state, ["qt", "config", "pagebuilder-config"], {})
  );
  const { buttonColor, darkButtonColor } = get(login, ["pageSetting"], {});
  const { darkPrimaryColor = "#4860BC", primaryColor = "#4860BC" } = general;
  const buttonBgColor = enableDarkMode
    ? darkButtonColor || darkPrimaryColor
    : buttonColor || primaryColor;
  const textColor =
    getTextContrast(buttonBgColor) === "dark" ? "#000" : "#fff";

  useEffect(() => {
    if (!enableEnterClick) return;
    if (!disable) {
      const handleKeyPress = (event) => {
        if (event?.key === "Enter") handleClick();
      };
      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }
  }, [enableEnterClick, disable, text, clickHandler]);

  const handleClick = async () => {
    if (!enableLoader) return clickHandler();
    setLoading(true);
    await clickHandler();
    setLoading(false);
  };

  return (
    <button
      className="auth--background-color auth--button"
      disabled={disable || loading}
      onClick={handleClick}
      styleName={disable || loading ? "custom-button opacity no-pointer" : "custom-button pointer"}
      style={{ color: textColor }}
    >
      {loading ? (
        <div styleName='loader'></div>
      ) : (
        text
      )}
    </button>
  );
};
